module.exports = __webpack_public_path__ + "static/img/tm-8.41bcc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-8.jpg
// module id = ayo/
// module chunks = 0